// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"autoscroll_wrapper_LhuRlyN","navButtons":"autoscroll_navButtons_2t7Trot"};